import { Col, Form, Input, InputNumber, Row, Select } from "antd";
import { FormInstance } from "antd/lib/form";
import { isString } from "lodash";
import React from "react";

type FormType = {
  form: FormInstance<any>;
  values?: any;
  submit: (values: any) => void;
  data: any;
};

export const SizeForm: React.FC<FormType> = (props) => {
  const { form, values, data, submit } = props;

  const {
    measureSizeGroups: { nodes: measureSizeGroups },
  } = data;

  const onFinish = (values: any) => {
    const input = {
      ...values,
      sizeSizeGroups: values.sizeSizeGroups?.map((sizeGroupId: any) => ({
        sizeGroupId,
      })),
    };
    submit(input);
  };

  return (
    <Form layout="vertical" form={form} initialValues={values} onFinish={onFinish}>
      <Row gutter={[24, 0]}>
        <Col span={12}>
          <Form.Item name="code" label="Code" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="value" label="Value" rules={[{ required: true, message: "is required" }]}>
            <InputNumber min={1} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name="sizeSizeGroups" label="Size Groups">
            <Select
              mode="multiple"
              showSearch
              allowClear
              optionLabelProp="label"
              filterOption={(input, option) => {
                let label = "";
                if (option?.label && isString(option.label)) label = option.label;
                let value = option?.value;
                return (
                  label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
              }}
            >
              {measureSizeGroups.map((sizeGroup: any) => (
                <Select.Option key={sizeGroup.id} value={sizeGroup.id} label={sizeGroup.code}>
                  {sizeGroup.code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
